import React, { Suspense } from "react";

const SettingsPage = React.lazy(() => import("@/pages/settings"));

export default function SettingsPageContainer() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
      <SettingsPage />
    </Suspense>
  );
}
